import { gameQueryOptions } from "@/api/fapinstructor/game/get-game";
import { createFileRoute } from "@tanstack/react-router";
import { GameBuilder } from "./-components/game-builder";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/game-builder/$gameId",
)({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      gameQueryOptions({
        gameId: opts.params.gameId,
      }),
    ),
  component: EditExistingGameRouteComponent,
});

function EditExistingGameRouteComponent() {
  const { gameId } = Route.useParams();
  const game = Route.useLoaderData();
  const { name, description, shared, splash, events, media } = game;

  return (
    <GameBuilder
      gameId={gameId}
      initialValues={{ name, description, shared, splash, media }}
      // @ts-ignore TODO: Eventually we should type the events properly.
      events={events}
    />
  );
}
